import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap, switchMap, tap } from 'rxjs/operators';
import { Observable, EMPTY, of } from 'rxjs';
import { OptionsService } from '@app/services/options/options.service';
import * as SettingsActions from '../actions/settings.actions';
import { ProductBarcodesService } from '@app/services/product-barcodes/product-barcodes.service';


@Injectable()
export class SettingsEffects {

  loadSettings$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SettingsActions.loadSettings),
      switchMap(() =>
        this._options.onGetOptions().pipe(
          map(data => SettingsActions.loadSettingsSuccess(data)),
          catchError(error => of(SettingsActions.loadSettingssFailure({ error }))))
      )
    );
  });

  submitSettings$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SettingsActions.submitSettings),
      switchMap(({ form }) => 
        this._options.onUpdateSettings(form).pipe(

          map(({ data })=> {
            if(form.locEnableAutoBarcodeGen == 1){
              this._productBarcodes.onAutoGenerate(true);
            }
            return SettingsActions.submitSettingsSuccess(data)
          }),
          catchError(error => of(SettingsActions.loadSettingssFailure({ error }))))
      ),
    );
  });

  constructor(private actions$: Actions, private _options: OptionsService, private _productBarcodes: ProductBarcodesService) { }

}
